export default {
  _IMAGE_URL: "https://uploads.backendservices.in/storage",
  _IMAGE_UPLOAD_URL: "https://uploads.backendservices.in/api",
};
